import React from 'react';
const communities = [{
  name: 'Broomfield',
  image: 'https://cdn.magicpatterns.com/uploads/56FmBC4Y3JfEunReQzrdWZ/broomfield.jpg'
}, {
  name: 'Denver',
  image: 'https://cdn.magicpatterns.com/uploads/rQi8p9EdkkDXLNCYNrxXQ8/bill-griepenstroh-Q9X_p5dDq_8-unsplash.jpg'
}, {
  name: 'Erie',
  image: 'https://cdn.magicpatterns.com/uploads/r2v4TQgJS4FwucPp73aLGR/andres-molina-3pon_PtzcVQ-unsplash.jpg'
}, {
  name: 'Lafayette',
  image: 'https://cdn.magicpatterns.com/uploads/83uyi5yexAqDbxBEpY3nqz/russell-smith-O-eYeUZDtck-unsplash.jpg'
}];
export function Communities() {
  return <section id="communities" className="py-20 md:py-32 bg-white" data-id="element-22">
      <div className="container mx-auto px-4 md:px-6" data-id="element-23">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-24">
          <div data-id="element-25">
            <span className="text-brand-copper tracking-[0.2em] text-sm font-semibold uppercase mb-4 block" data-id="element-26">
              Communities
            </span>
            <h2 className="text-4xl md:text-5xl font-serif text-brand-charcoal" data-id="element-27">
              Where you'll want to live
            </h2>
          </div>
          <a href="#" className="text-brand-copper hover:text-brand-charcoal font-medium transition-colors border-b border-brand-copper pb-1 self-start md:self-auto" data-id="element-28">
            View All Communities
          </a>
        </div>

        <div className="flex overflow-x-auto pb-8 -mx-4 px-4 md:mx-0 md:px-0 md:grid md:grid-cols-4 gap-4 md:gap-6 snap-x snap-mandatory hide-scrollbar" data-id="element-29">
          {communities.map(community => <div key={community.name} className="min-w-[85vw] md:min-w-0 relative h-[400px] md:h-[500px] rounded-2xl overflow-hidden group snap-center cursor-pointer" data-id="element-30">
              <div className="absolute inset-0 bg-cover bg-center transition-transform duration-1000 group-hover:scale-110" style={{
            backgroundImage: `url(${community.image})`
          }} data-id="element-31"></div>
              <div className="absolute inset-0 bg-gradient-to-t from-brand-stone-900/80 via-brand-stone-900/20 to-transparent" data-id="element-32"></div>

              <div className="absolute inset-0 p-8 flex flex-col justify-end" data-id="element-33">
                <h3 className="text-3xl font-serif text-white mb-2 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500" data-id="element-34">
                  {community.name}
                </h3>
                <div className="overflow-hidden" data-id="element-35">
                  <span className="text-brand-copper font-medium flex items-center gap-2 transform translate-y-full group-hover:translate-y-0 transition-transform duration-500 opacity-0 group-hover:opacity-100" data-id="element-36">
                    Explore {community.name}
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
      <style data-id="element-37">{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </section>;
}